export default "__VITE_ASSET__C0y6Auxb__"